import { sortReplies } from '@btime/helpers'
import React from 'react'

import { useGroupedRepliesByCategory } from '../../../../containers/dynamic/presentationList/categories/_data/groupByCategories'
import RepliesSection from './RepliesSection'
import Separator from '../../../../components/pdf/Separator'
import View from '../../../../components/pdf/View'
import ServiceOrderHeader from '../../../serviceOrders/pdf/general/ServiceOrderHeader'
import Overview from '../../../serviceOrders/pdf/general/Overview'

const ChildrenRepliesSection = ({ serviceOrder }) => {
  const replies = sortReplies(serviceOrder.replies)
  const categories = useGroupedRepliesByCategory(sortReplies(replies))

  return (
    <View noWrap>
      <Separator weight={20} />
      <ServiceOrderHeader serviceOrder={serviceOrder} />
      <Overview serviceOrder={serviceOrder} />
      <RepliesSection serviceOrder={serviceOrder} categories={categories} />
    </View>
  )
}

export default ChildrenRepliesSection
